import { render } from "./DeckBuilder.vue?vue&type=template&id=d514b5c0&scoped=true"
import script from "./DeckBuilder.vue?vue&type=script&lang=js"
export * from "./DeckBuilder.vue?vue&type=script&lang=js"

import "./DeckBuilder.vue?vue&type=style&index=0&id=d514b5c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d514b5c0"]])

export default __exports__